import {
    actions as bookmakersInfoActions,
} from '../common/bookmakersInfo'
import {
    actions as freeBetsActions,
} from '../common/freeBets'
import {
    actions as bookmakersListActionTypes,
} from '../common/bookmakersList'
import {
    actions as betActions,
} from '../common/bet'

const freeBetsMiddleware = store => next =>
        (action) => {
            const result = next(action)

            switch (action.type) {
                case bookmakersInfoActions.actionTypes.ADD_SELECTED_BET:
                case bookmakersInfoActions.actionTypes.DELETE_BET:
                case bookmakersInfoActions.actionTypes.CLEAR_SELECTED_BETS:
                case bookmakersInfoActions.actionTypes.BUILD_BET_REQUEST:
                case bookmakersInfoActions.actionTypes.SET_SELECTED_BOOKMAKER:
                case bookmakersListActionTypes.actionTypes.SET_LOGGEDOUT:
                case betActions.actionTypes.CLEAR_PLACED_BET_DETAILS:
                case betActions.actionTypes.PLACE_BET_SUCCESS:
                    store.dispatch(freeBetsActions.clearFreeBet())
                    break
                default:
            }

            return result
        }

export default freeBetsMiddleware



// WEBPACK FOOTER //
// /src/js/App/freebets.middleware.js